import Service from './service';
import { getServicesUrl } from '../../setup';
import { APIVersion } from '../../types/main';
import Security from './security';

class CommonContent extends Service {
    static generateTemplates(data) {
        return Service.postRequest(`${getServicesUrl(APIVersion.V11)}/templates/generateTemplate`, data, { isSecure: true });
    }

    static getAllDatasets() {
        return Service.getRequest(`${getServicesUrl()}/rendertemplates/datasets/all`, { isSecure: true });
    }

    static async getResourceSets(language = 'en', config = undefined) {
        await Security.generateApplicationTokensIfNeeded();

        return Service.getRequest(
            `${getServicesUrl()}/resourcesets?language=${language}`,
            config,
        );
    }

    static async getResourceSetsByName(name, language = 'en') {
        await Security.generateApplicationTokensIfNeeded();

        return Service.getRequest(
            `${getServicesUrl(APIVersion.V11)}/resourcesets/${name}?language=${language}`,
        );
    }

    static getRenderTemplate(id) {
        return Service.getRequest(`${getServicesUrl()}/rendertemplates/${id}`, { isSecure: true });
    }

    static portPreviewTemplate(data) {
        return Service.postRequest(`${getServicesUrl(APIVersion.V21)}/templates/preview`, data, { isSecure: true });
    }
}

export default CommonContent;
